import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SlugPipe } from './slug/slug.pipe';
import { CMSAssetPipe } from '../../cms/pipe/asset/asset.pipe';

@NgModule({
    declarations: [
        CMSAssetPipe,
        SlugPipe
    ],
    exports: [
        CMSAssetPipe,
        SlugPipe
    ],
    imports: [
        CommonModule
    ]
})
export class PipeModule { }
